import React from 'react';
import { Tooltip, Icon } from 'antd';
import {
  Container,
  TitleContainer,
  Title,
  TitleHelp,
  ListContainer,
  ListGridContainer,
  ListItem,
  EmptyListContainer,
  EmptyListImage,
  EmptyListHelpText,
} from './styles';

import EmptyList from '../../images/empty-list.svg';
import VariableBubble from '../../images/variable-bubble.svg';
import { TEMPLATE_VARIABLES_SIDEBAR } from './translationValues';
import { useTranslation } from 'react-i18next';

const NAMESPACES = ['TEMPLATE_VARIABLES_SIDEBAR']
const VariablesList = props => {
 const { t } = useTranslation(NAMESPACES);
 return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <TitleContainer>
        <Title>
          <p>
            {t(TEMPLATE_VARIABLES_SIDEBAR.VARIABLES_SIDEBAR_TITLE.key, TEMPLATE_VARIABLES_SIDEBAR.VARIABLES_SIDEBAR_TITLE.value)}{' '}
            {props.documentVariables &&
              props.documentVariables.length > 0 &&
              `(${props.documentVariables.length})`}
          </p>
        </Title>
        <TitleHelp>
          <Tooltip placement="bottom" title={t(TEMPLATE_VARIABLES_SIDEBAR.VARIABLES_SIDEBAR_DESCRIPTION.key, TEMPLATE_VARIABLES_SIDEBAR.VARIABLES_SIDEBAR_DESCRIPTION.value)}>
            <Icon type="info-circle" />
          </Tooltip>
        </TitleHelp>
      </TitleContainer>
      <ListContainer>
        {props.documentVariables && props.documentVariables.length > 0 ? (
          <ListGridContainer>
            {props.documentVariables.map((variable, index) => (
              <ListItem key={variable.placeHolderText}>
              <div className="variableDetail">
                <div className="variable-count">{index + 1}.</div>
                {variable.length && (
                  <div className="variable-icon">
                    <img src={VariableBubble} alt="VariableBubble" />
                    <div className="variable-length">{variable.length || 'NA'}</div>
                  </div>
                )}
                <div className="variable-name">{variable.placeHolderText || variable.value}</div>
              </div>
              {(variable.type === 'ListString' || variable.type === 'ListDate') && (
                <Tooltip
                  placement="right"
                  title={t(
                    TEMPLATE_VARIABLES_SIDEBAR.MULTI_VALUE_VARIABLE_TOOLTIP.key,
                    TEMPLATE_VARIABLES_SIDEBAR.MULTI_VALUE_VARIABLE_TOOLTIP.value,
                  )}
                >
                  <div className="variable-type">L</div>
                </Tooltip>
              )}
              {variable.type === 'Date' && (
                <Tooltip
                  placement="right"
                  title={t(
                    TEMPLATE_VARIABLES_SIDEBAR.DATE_VARIABLE_TOOLTIP.key,
                    TEMPLATE_VARIABLES_SIDEBAR.DATE_VARIABLE_TOOLTIP.value,
                  )}
                >
                  <div className="variable-type">D</div>
                </Tooltip>
              )}
              {variable.type === 'table' && (
                <Tooltip
                  placement="right"
                  title={t(
                    TEMPLATE_VARIABLES_SIDEBAR.TABLE_VARIABLE_TOOLTIP.key,
                    TEMPLATE_VARIABLES_SIDEBAR.TABLE_VARIABLE_TOOLTIP.value,
                  )}
                >
                  <div className="variable-type">T            
                  </div>
                </Tooltip>
              )}
              {variable.type === 'boolean' && (
                <Tooltip
                  placement="right"
                  title={t(
                    TEMPLATE_VARIABLES_SIDEBAR.BOOLEAN_VARIABLE_TOOLTIP.key,
                    TEMPLATE_VARIABLES_SIDEBAR.BOOLEAN_VARIABLE_TOOLTIP.value,
                  )}
                >
                  <div className="variable-type">B</div>
                </Tooltip>
              )}
            </ListItem>
            ))}
          </ListGridContainer>
        ) : (
          <EmptyListContainer>
            <EmptyListImage>
              <img src={EmptyList} alt="empty-list" />
            </EmptyListImage>
            <EmptyListHelpText>
              {t(TEMPLATE_VARIABLES_SIDEBAR.NO_VARIABLES_IN_TEMPLATE_DESCRIPTION.key, TEMPLATE_VARIABLES_SIDEBAR.NO_VARIABLES_IN_TEMPLATE_DESCRIPTION.value)}
            </EmptyListHelpText>
          </EmptyListContainer>
        )}
      </ListContainer>
    </Container>
  );
};

export default VariablesList;
